import React, { useState } from "react";
import ErrorMessage from "./shared/ErrorMessage";
import SharedButton from "./shared/SharedButton";
import SharedInput from "./shared/SharedInput";
import { app_url, emailValidity, useQuery } from "./shared/Utils";
import dwlLogo from "../images/dwl_logo_login.png";
import { Link } from "react-router-dom";

const ResetPassword = () => {
  let query = useQuery();
  let isInvalidLink = query.get("isInvalidLink");
  const [isLink] = useState(isInvalidLink);
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const handleInputChange = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
  };
  const submitReset = (e) => {
    e.preventDefault();
    if (email === null || !emailValidity(email)) {
      setEmailError(true);
      return false;
    }

    let currEmail = {
      Email: email,
    };

    fetch(`${app_url}account/forgetpassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(currEmail),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setEmail("");
        setEmailConfirm(true);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div className="login-container">
      <div id="resetBox" className="login-box">
        <div className="password-reset">
          <div className="reset-logo t-center">
            <img
              src={dwlLogo}
              alt="dwl logo"
              className="img-fluid dwl-login-logo"
            />
          </div>
          {emailConfirm ? (
            <>
              <div className="access-box">
                <h2 className="t-center reset-text">Email Sent!</h2>
              </div>
              <p className="email-inst t-center">
                Check your inbox for a reset link.
              </p>
              <div className="forget-pass t-center">
                <Link to="/" className="forgot-text">
                  Return to Log In
                </Link>
              </div>
            </>
          ) : (
            <>
              <div className="reset-page">
                <div className="access-box">
                  <h2 className="t-center reset-text">
                    {isLink ? "Request a new setup link" : "Reset Password"}
                  </h2>
                </div>
                <p className="email-inst t-center">
                  {isLink
                    ? "Confirm the email address the original setup link was sent to, and we will instantly send a new link."
                    : "We can email you instructions to reset your password."}
                </p>
                <div className="reset-form">
                  <div className="vd_input-wrapper">
                    <label htmlFor="email">Email Address</label>
                    <div className="input-with-icon">
                      <span className="menu-icon">
                        <i className="fa fa-user"></i>
                      </span>
                      <SharedInput
                        id="email"
                        name="Email Address"
                        inputType="email"
                        inputChange={handleInputChange}
                        value={email}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="t-center">
                <SharedButton
                  id="btn-request"
                  addClass="btn-reset-password w-100 minh-34"
                  btnName={isLink ? "Submit" : "Send Reset Email"}
                  handleClick={submitReset}
                />
              </div>
              <ErrorMessage
                id="loginError"
                errorClass={`login-error ${emailError ? "" : "d-none"}`}
                message="The provided email address is not correct!"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
